// extracted by mini-css-extract-plugin
export default {"recos":"H6-z","productCardOverride":"I6-z","rowHasBadge":"J6-z"};